import { render } from "./Pronostico.vue?vue&type=template&id=8d4407e0"
import script from "./Pronostico.vue?vue&type=script&lang=js"
export * from "./Pronostico.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__